import React from 'react';
import './ErrorSection.css';

interface ErrorSectionProps {
  error: string | null;
  onTryAgain: () => void;
}

const ErrorSection: React.FC<ErrorSectionProps> = ({ error, onTryAgain }) => {
  return (
    <section className="app-section error-section">
      <div className="app-card error-container">
        <div className="error-icon">
          <i className="fas fa-exclamation-triangle"></i>
        </div>
        <h2 className="app-title">Error</h2>
        <p className="error-message">{error}</p>
        <button 
          onClick={onTryAgain} 
          className="app-button secondary-button"
        >
          <i className="fas fa-redo"></i> Try Again
        </button>
      </div>
    </section>
  );
};

export default ErrorSection;